import { GET_ADITIONAL_DEPOSIT, GET_ALL_DEPOSITS, GET_DEPOSIT_MOVEMENTS } from './../constants';
import { handleActions } from "redux-actions"

export const deposits  = handleActions(
  {
    [ GET_ALL_DEPOSITS ]: (state, action) => {
        return { ...state, info: action.payload.data }
    },
    [ GET_ADITIONAL_DEPOSIT ]: (state, action) => {
        return { ...state, aditional: action.payload.data }
    },
    [ GET_DEPOSIT_MOVEMENTS ]: (state, action) => {
        return { ...state, movements: action.payload.data }
    }
  }, {}
)